import { render } from "./brandIcons.vue?vue&type=template&id=815d3ce6&scoped=true"
import script from "./brandIcons.vue?vue&type=script&lang=js"
export * from "./brandIcons.vue?vue&type=script&lang=js"

import "./brandIcons.vue?vue&type=style&index=0&id=815d3ce6&lang=scss&scoped=true"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-815d3ce6"]])

export default __exports__